import React, { useEffect, useRef } from "react";
import { track } from "../utils/analytics";

/**
 * Cross-promo strip under the public conjugator panel, pointing at the Iʿrāb
 * tool — the natural next step once a verb is understood (mirrors how
 * sarf.html's cta-band cross-links irab.html). Same-origin /irab keeps the
 * visitor on whatever host they're already on (prod, dev, LAN).
 *
 * Styled on MacAppCta — the same inline-offer shape; colours via inline
 * `style` with pre-baked alpha variables (the `dt-*` tokens are `var()`-
 * backed, so Tailwind slash opacity silently produces nothing).
 */
export default function IrabToolCta({ context = "sarf-public" }) {
  const seen = useRef(false);

  useEffect(() => {
    // StrictMode double-invokes effects in development; only count the view once.
    if (seen.current) return;
    seen.current = true;
    track("irab-cta-view", { context });
  }, [context]);

  return (
    <section className="w-full max-w-3xl mx-auto px-3 sm:px-4 pb-8">
      <div
        className="px-4 py-3.5 rounded-xl flex flex-col sm:flex-row sm:items-center gap-3"
        style={{ background: "var(--gold-bg)", border: "1px solid var(--panel-line)" }}
      >
        <div className="flex-1">
          <p className="text-sm font-semibold text-dt-parchment">
            Want the full sentence analyzed?
          </p>
          <p className="text-xs text-dt-parchment-dim mt-0.5">
            The Iʿrāb tool takes any Arabic sentence and explains every word —
            its type, root, and grammatical role, with the reason. Free daily,
            no account needed.
          </p>
        </div>
        <a
          href="/irab"
          onClick={() => track("irab-cta-click", { context })}
          className="shrink-0 px-4 py-2 rounded-xl bg-dt-gold text-dt-ink hover:brightness-105 text-sm font-semibold transition-[filter] no-underline text-center"
        >
          Try the Iʿrāb tool
        </a>
      </div>
    </section>
  );
}
